import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N2Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState("all");
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        const checkAdvancedSearchObject = JSON.stringify(advancedSearchText) === JSON.stringify({});
        if (checkAdvancedSearchObject) {
            navigate(`/search/n2/${textSearch ? textSearch : advancedSearchText}`);
        } else {
            const urlParams = new URLSearchParams(advancedSearchText).toString();
            navigate(`/search/n2/advanced?${urlParams}`);
        }
        setSubmitSearch(false);
    }, [textSearch, navigate, advancedSearch, advancedSearchText]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    const arrRules = [
        {
            title: "Marker ID",
            value: "marker_id",
        },
        {
            title: "Position",
            value: "position",
        },
        {
            title: "Chromosome No",
            value: "chromosome_no",
        },
    ];

    return (
        <MainLayout
            pathname="/search/n2"
            arrRules={arrRules}
            header="Genetic Maker Structural Variation"
            exampleText={
                <div>
                    Examples - Marker ID:{" "}
                    <span className="text-primary">RM462</span>,{" "}
                    <span className="text-primary">RM283</span>,{" "}
                    <span className="text-primary">RM577</span>{" "}
                    Position: <span className="text-primary">1-85160</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearch={setAdvancedSearch}
            advancedSearchText={advancedSearchText}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
